import {
    Component,
    DoCheck,
    Input,
    ViewChild,
} from '@angular/core';

@Component({
    selector: 'app-pdf-viewer',
    templateUrl: './viewer-pdf.component.html',
    styleUrls: ['./viewer-pdf.component.css'],
})
export class ViewerPDFComponent implements DoCheck {

    @Input()
    pdfSrc: string;

    @Input()
    pageNumber = 1;

    @Input()
    zoom = 1.0;

    @Input()
    bgColor = 'rgba(0,0,0,0)'; // Default background color is white

    @ViewChild("pdfIFrame") pdfIFrame;
    private pdfIFrameInitialized: boolean = false;

    ngDoCheck(): void {
        if (this.pdfIFrameInitialized || this.pdfSrc == null) return;
        this.pdfIFrameInitialized = true;
        this.pdfIFrame.nativeElement.src = this.pdfSrc;
    }

}